// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// AddCourseToInstitutionCourseBlockDetailHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ResultDTO from '../models/ResultDTO';

interface Request {
    courseId: string | null;
    institutionCourseBlockDetailId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            courseId: '00000000-0000-0000-0000-000000000000',
            institutionCourseBlockDetailId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    courseId: 'courseId',
    institutionCourseBlockDetailId: 'institutionCourseBlockDetailId',
}

interface Result extends ResultDTO {
    status: boolean;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            status: false,
        },
        initValues);
    },
    status: 'status',
}

export { Request, Result };